<axis-card>
  <axis-card-body>
    <div class="_display-flex _justify-content-end">Updated June 13, 2025</div>
    <div class="_mt-xlarge">
      <p class="_text-large _text-bold">
        I UNDERSTAND THE PROTECTION AFFORDED BY UNINSURED AND UNDERINSURED MOTORISTS COVERAGE AND THE SELECTION(S) I
        HAVE MADE REGARDING UNINSURED AND UNDERINSURED MOTORISTS COVERAGE. I FURTHER UNDERSTAND AND AGREE THAT MY
        SELECTION(S) WILL APPLY TO THIS POLICY AND ALL FUTURE TRANSFERS, SUBSTITUTIONS, AMENDMENTS, ALTERATIONS,
        MODIFICATIONS, REINSTATEMENTS OR REPLACEMENTS OF THIS POLICY, UNLESS I MAKE AN ELECTION IN WRITING TO CHANGE MY
        SELECTION(S) WHICH IS RECEIVED AND APPROVED BY THE COMPANY.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold">
        WE ARE ALSO NOTIFYING YOU OF SPECIFIC DISCLOSURES FOR THE FOLLOWING STATES AS SET FORTH BELOW:
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Arizona</p>
      <p class="_text-large">
        I understand the protection afforded by Uninsured and Underinsured Motorist Coverage and the selection(s) I have
        made on this Notice regarding Uninsured and Underinsured Motorist Coverage. I further understand and agree to
        the following: this form reflects the Company’s offer of Uninsured and Underinsured Motorist Coverage options
        made to me; my selection(s) will apply to this policy and all future transfers, substitutions, amendments,
        alterations, modifications, reinstatements or replacements of this policy, unless I make an election in writing
        to change my selection(s) which is received and approved by the Company; and my policy Declarations Page(s) will
        be sent to me to confirm that my policy contains the Uninsured and Underinsured Motorist Coverage I selected.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Connecticut</p>
      <p class="_text-bold _text-large">
        WHEN YOU SIGN THIS FORM AND MAKE A WRITTEN REQUEST FOR A LESSER LIMIT OF LIABILITY, YOU ARE CHOOSING A REDUCED
        PREMIUM, BUT YOU ARE ALSO CHOOSING NOT TO PURCHASE CERTAIN VALUABLE COVERAGE WHICH PROTECTS YOU AND YOUR FAMILY.
        IF YOU ARE UNCERTAIN ABOUT HOW THIS DECISION WILL AFFECT YOU, YOU SHOULD GET ADVICE FROM YOUR INSURANCE AGENT OR
        ANOTHER QUALIFIED ADVISOR.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Florida</p>
      <p class="_text-bold _text-large">
        YOU ARE ELECTING NOT TO PURCHASE CERTAIN VALUABLE COVERAGE WHICH PROTECTS YOU AND YOUR FAMILY OR YOU ARE
        PURCHASING UNINSURED MOTORIST LIMITS LESS THAN YOUR BODILY INJURY LIABILITY LIMITS WHEN YOU SIGN THIS FORM.
        PLEASE READ CAREFULLY.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Georgia</p>
      <p class="_text-large">
        If you have chosen to accept Uninsured Motorists coverage from your automobile insurance company, and have any
        questions after reading this statement regarding Uninsured Motorists coverage or the amount of coverage you have
        selected, your agent or company representative will be able to assist you. You should have chosen the amount of
        Uninsured Motorists coverage you want based on this question: If I get hit by someone with little or no
        liability insurance, how much protection do I need to cover the cost associated with car repair, medical bills,
        other expenses,lost wages? If the person who hits your automobile has no liability coverage or liability
        coverage equal to or less than the Uninsured Motorists amount you chose, your total automobile insurance
        recovery (from all companies involved) may not exceed the amount of Uninsured Motorists coverage you chose.
      </p>
      <p class="_text-large">
        The purpose of this notice is informational. This notice does not change or replace the wording in your policy.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Louisiana</p>
      <p class="_text-large">
        The choice indicated and initialed on this form will apply to all persons and/or entities insured under this
        policy. This choice shall apply to the motor vehicles described in this policy and to any replacement vehicles,
        to all renewals of this policy, and to all reinstatement, substitute or amended policies until a written request
        is made for a change to the Bodily Injury Liability Limits, the UMBI limits or UMBI Coverage.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Mississippi</p>
      <p class="_text-bold _text-large">
        Uninsured Motorist (“UM”) insurance is recoverable by you under your policy should the owner or operator of an
        uninsured or underinsured vehicle be found to be legally at fault for injuries or damages sustained by you. Your
        rejection of UM insurance would mean that you would not be covered by your insurance company for damages
        sustained by you from an owner of operator of an uninsured or underinsured vehicle. The selection or rejection
        of this coverage in whole or in part should be made by you after knowingly and intelligently considering the
        matter.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">New Jersey</p>
      <p class="_text-large">
        I understand that no person, including, but not limited to, an insurance company, its producers or
        representatives, shall be liable in an action for damages on account of the election of a given level of
        Uninsured and Underinsured Motorists Coverage by a named insured so long as those limits provide at least the
        minimum coverage required by law. I also understand that this immunity does not apply to those situations where
        the insurance company, its producers or representatives, act or fail to act in a manner which is willful, wanton
        or grossly negligent.
      </p>
      <p class="_text-large">
        I understand the protection afforded by Uninsured and Underinsured Motorists Coverage and the selection(s) I
        have made on this Notice regarding Uninsured and Underinsured Motorists Coverage. The limits available for
        Uninsured and Underinsured Motorists Coverage have been explained to me, and my choices are shown. I further
        understand and agree that my selection(s) will apply to this policy and all future transfers, substitutions,
        amendments, alterations, modifications, reinstatements or replacements of this policy, unless I make an election
        in writing to change my selection(s) which is received and approved by the Company.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">New Mexico</p>
      <p class="_text-bold _text-large">LIMITATIONS OF UNINSURED MOTORIST/UNDERINSURED MOTORIST (UM/UIM) COVERAGE</p>
      <p class="_text-bold _text-large">
        Please be aware of the limitations of your Uninsured Motorist/Underinsured Motorist (UM/UIM) coverage. If you
        suffer a loss with an Uninsured or Underinsured Motorist, the total payment you receive will be limited to the
        greater of either your UM/UIM limit or the other party’s liability coverage limit, subject to other policy
        provisions. If you have any questions about your coverage, please contact your insurance broker.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Oklahoma</p>
      <p class="_text-large">
        Oklahoma law gives you the right to buy Uninsured Motorist coverage in the same amount as your bodily injury
        liability coverage. THE LAW REQUIRES US TO ADVISE YOU OF THIS VALUABLE RIGHT FOR THE PROTECTION OF YOU, MEMBERS
        OF YOUR FAMILY, AND OTHER PEOPLE WHO MAY BE HURT WHILE RIDING IN YOUR INSURED VEHICLE. YOU SHOULD SERIOUSLY
        CONSIDER BUYING THIS COVERAGE IN THE SAME AMOUNT AS YOUR LIABILITY INSURANCE COVERAGE LIMIT.
      </p>
      <p class="_text-large">
        Uninsured Motorist coverage, unless otherwise provided in your policy, pays for bodily injury damages to you,
        members of your family who live with you, and other people riding in your car who are injured by: (1) an
        uninsured motorist, (2) a hit-and-run motorist, or (3) an insured motorist who does not have enough liability
        insurance to pay for bodily injury damages to any insured person (underinsured motorist). Uninsured Motorist
        coverage, unless otherwise provided in your policy, protects you and family members who live with you while
        riding in any vehicle or while a pedestrian. THE COST OF THIS COVERAGE IS SMALL COMPARED WITH THE BENEFITS!
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Oregon</p>
      <p class="_text-large">
        I understand the protection afforded by Uninsured Motorists Bodily Injury Coverage and Uninsured Motorists
        Property Damage Coverage – Private Passenger Types and the selection(s) I have made on this Notice regarding
        Uninsured Motorists Bodily Injury Coverage and Uninsured Motorists Property Damage Coverage – Private Passenger
        Types. I further understand and agree that my selection(s) will apply to this policy and all future transfers,
        substitutions, amendments, alterations, modifications, reinstatements or replacements of this policy, unless I
        make an election in writing to change my selection(s), and such request is received and approved by the Company.
        I also understand that if (i) I had previously selected the minimum Uninsured Motorists Bodily Injury Coverage
        limits and the Uninsured Motorists Property Damage Coverage - Private Passenger Types limits or solely the
        minimum Uninsured Motorists Bodily Injury Coverage limits required by statute for my last policy, (ii) there has
        been an increase in the statutory minimum Uninsured Motorists Bodily Injury Coverage limits and/or Uninsured
        Motorists Property Damage Coverage - Private Passenger Types limits which are to take effect during my renewal
        policy period and (iii) the Company has not received my elections of either limits higher than the required
        minimum statutory limits or a rejection of limits (if eligible to do so) prior to renewal policy inception, then
        the Uninsured Motorists Bodily Injury Coverage limits and Uninsured Motorists Property Damage Coverage – Private
        Passenger Types limits (as applicable) for my renewal policy will automatically be equal to the new minimum
        statutory Uninsured Motorists Bodily Coverage limits and Uninsured Motorists Property Damage Coverage – Private
        Passenger Types limits. By signing, I acknowledge that I have been offered Uninsured Motorists Bodily Injury
        Coverage with limits equal to my Bodily Injury Liability Coverage and I acknowledge that I have been offered
        Uninsured Motorists Bodily Injury Coverage at limits lower than the Bodily Injury Liability Coverage limits of
        my policy.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline">Pennsylvania</p>
      <p class="_mb-small _text-large _text-underline">If you reject UM coverage:</p>
      <p class="_text-large">
        By signing this waiver I am rejecting uninsured motorist coverage under this policy, for myself and all
        relatives residing in my household. Uninsured coverage protects me and relatives living in my household for
        losses and damages suffered if injury is caused by the negligence of a driver who does not have any insurance to
        pay for losses and damages. I knowingly and voluntarily reject this coverage.
      </p>
      <p class="_mb-small _text-large _text-underline">If you reject stacked UM coverage:</p>
      <p class="_text-large">
        By signing this waiver, I am rejecting stacked limits of uninsured motorist coverage under the policy for myself
        and members of my household under which the limits of coverage available would be the sum of limits for each
        motor vehicle insured under the policy. Instead, the limits of coverage that I am purchasing shall be reduced to
        the limits stated in the policy. I knowingly and voluntarily reject the stacked limits of coverage. I understand
        that my premiums will be reduced if I reject this coverage.
      </p>
      <p class="_mb-small _text-large _text-underline">If you reject UIM coverage:</p>
      <p class="_text-large">
        By signing this waiver I am rejecting underinsured motorist coverage under this policy, for myself and all
        relatives residing in my household. Underinsured coverage protects me and relatives living in my household for
        losses and damages suffered if injury is caused by the negligence of a driver who does not have enough insurance
        to pay for all losses and damages. I knowingly and voluntarily reject this coverage.
      </p>
      <p class="_mb-small _text-large _text-underline">If you reject stacked UIM coverage:</p>
      <p class="_text-large">
        By signing this waiver, I am rejecting stacked limits of underinsured motorist coverage under the policy for
        myself and members of my household under which the limits of coverage available would be the sum of limits for
        each motor vehicle insured under the policy. Instead, the limits of coverage that I am purchasing shall be
        reduced to the limits stated in the policy. I knowingly and voluntarily reject the stacked limits of coverage. I
        understand that my premiums will be reduced if I reject this coverage.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Rhode Island</p>
      <p class="_mt-medium _text-large __text-underline">
        Only if your policy has minimum liability limits, then you may reject UM/UIM coverage and the following applies:
      </p>
      <p class="_mt-medium _text-large">
        In order to make sure that you are aware of the risks of going without uninsured/underinsured motorist bodily
        injury coverage, the State of Rhode Island <span class="_text-bold">requires</span> us to obtain your signature
        showing that you have read this document and understand this warning <span class="_text-bold"> before</span> we
        are allowed to sell your motor vehicle insurance without uninsured/underinsured motorist bodily injury
        coverage.<span class="_text-bold _text-large"
          >IF YOU CHOOSE NOT TO BUY UNINSURED/UNDERINSURED MOTORIST BODILY INJURY COVERAGE YOU MIGHT HAVE NO MOTOR
          VEHICLE INSURANCE COVERAGE FOR YOUR OWN INJURIES IF YOU ARE HIT BY AN UNINSURED MOTORIST.</span
        >. Many motorists will ignore mandatory auto insurance laws, and many motorists passing through from another
        state will not have insurance. Most uninsured/underinsured motorists do not have assets or money to pay you for
        your injuries, even if you win a lawsuit against them. Uninsured/underinsured motorist bodily injury coverage
        may be your only protection.
      </p>
      <p class="_text-bold _text-large">
        The Department of Business Regulation of the State of Rhode Island STRONGLY RECOMMENDS that most motorists
        obtain uninsured/underinsured motorists bodily injury coverage as part of their motor vehicle insurance package.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">South Carolina</p>
      <p class="_text-large">
        By my signature, I acknowledge that I have read – or I have had read to me – the explanations and offers of
        additional uninsured motorist coverage and optional underinsured motorist coverage. I understand that the
        explanations of these coverages are intended only to be brief descriptions of additional uninsured motorist
        coverage and optional underinsured motorist coverage, and that payment of benefits under either of these
        coverages is subject both to the terms and conditions of my automobile insurance policy and the laws of the
        State of South Carolina.
      </p>
      <p class="_mt-xlarge _text-large">
        My signature further acknowledges that I understand the coverages as they have been explained to me, and the
        type and amounts of coverage marked on the preceding pages have been selected by me. This is the type and amount
        of insurance coverage I wish to purchase.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline _mb-small">Washington</p>
      <p class="_text-bold _text-large">
        In order to provide for an informed decision of the potential consequences of rejecting underinsured motorist
        coverage; the undersigned acknowledges that by rejecting underinsured motorist coverage there is exposure to the
        risk of not being sufficiently insured for injury and/or damages when involved in an accident with a driver of
        an underinsured vehicle.
      </p>
    </div>
    <div class="_mtb-xlarge">
      <p class="_text-large _text-bold _text-underline">West Virginia</p>
      <p class="_mb-small _text-underline _text-large">UM Coverage:</p>
      <p class="_text-bold _text-large">
        I have read the IMPORTANT NOTICE, attached, on UNinsured motor vehicle coverage and understand how this coverage
        works. I have been given the opportunity to select limits of UNinsured motor vehicle coverage listed above. By
        making a selection, I am rejecting the other remaining offers of coverage.
      </p>
      <p class="_mb-small _text-underline _text-large">UIM Coverage:</p>
      <p class="_text-bold _text-large">
        I have read the IMPORTANT NOTICE, attached, on UNDERinsured motor vehicle coverage and understand how this
        coverage works. I have been given the opportunity to select or reject limits of UNDERinsured motor vehicle
        coverage listed above. By making a selection for coverage, I am rejecting the other remaining offers of
        coverage.
      </p>
    </div>
  </axis-card-body>
</axis-card>
